// extracted by css-extract-rspack-plugin
export default {"editorContainer":"RichTextEditor_editorContainer__iISNK","fillHeight":"RichTextEditor_fillHeight__VW7Ns"};